import React from "react";
import {useDispatch, connect} from 'react-redux';
import IconButton from '@mui/material/IconButton';
import Typography from "@mui/material/Typography";
import EditIcon from '@mui/icons-material/Edit';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LayerDataSelection from './LayerDataSelection';
import LayerSelection from './LayerSelection';
import ColorRampSelector from './ColorRampSelector';
import { toggleLayerState } from '../actions/index';
import {updateBms, updateSld} from "../actions";
import { generateSld } from '../utils/style-generator'
import { ColorUtils, calculateFieldStats, calculatePercentiles } from '../utils/helpers';
import { Button, Paper } from "@mui/material";
import StyleEditor from "./StyleEditor";
import ColorDivisonSelector from "./ColorDivisonSelector";
import StyleTypeSelector from "./StyleTypeSelector";
import Slider from '@mui/material/Slider';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import preloaded from '../utils/data.json';

const mapStateToProps = state => {
    return {
        map: state.MapReducer
    }
};

const DataPanel = (props) => {
    const dispatch = useDispatch();

    const [showPanel, setShowPanel] = React.useState(false);
    const [showBMaps, setShowBMaps] = React.useState(false);
    
    const [opacity, setOpacity] = React.useState(100);
    const [opacityBASE, setOpacityBASE] = React.useState(90);
    const [colorRamp, setColorRamp] = React.useState(props.map.colorRamp);
    const [activeField, setActiveField] = React.useState(props.map.activeField);
    const [division, setDivision] = React.useState(9); //itt is kell állítani?
    const [styleType, setStyleType] = React.useState('categorical');
    const [styleTypes, setStyleTypes] = React.useState(['range', 'categorical']);
    const [stats, setStats] = React.useState({min:0, max:0, percentiles:[], values:[]})
    const [layerStyle, setLayerStyle] = React.useState({
        colorRamp: colorRamp,
        breaks: [],
        opacity: 1
    });

    const [openStyleEditor, setOpenStyleEditor] = React.useState(false);

    const hideDP = (props) => {
        setShowPanel(false)
    }

    const loadFieldStats = (props) => {
        if(!Boolean(props.map.activeLayer) || !Boolean(activeField)){
            return;
        }
        calculateFieldStats(
            "http://193.225.239.5/geoserver/allum_project/ows",
            props.map.activeLayer,
            activeField
        ).then(_stats => {
            setStats(_stats);
        })
    }

    const reloadSld = () => {
        const sld = generateSld({
            "name": props.map.activeLayer.split(':')[1],
            "fieldName": activeField,
            "style": layerStyle
        }, styleType)
        //add sld to server
        fetch('http://193.225.239.5/backend2/saveSld', {//'http://localhost:8081/saveSld'
        // fetch('http://localhost:8081/saveSld', {//'http://193.225.239.5/backend2/saveSld'
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                sldData: sld
            })
        }).then(r=>r.json()).then(r=>{
            if(r.error){
                console.log("Error saving sld");
            }else{
                dispatch(updateSld(props.map.activeLayer, r.data.id, layerStyle));
            }
            //dispatch(updateSld(props.map.activeLayer, sld, layerStyle));
        })
    }

    React.useEffect(()=>{
        let curSType = styleType;
        const supportedFieldTypes = Object.keys(props.map.layers[props.map.activeLayer].fieldStyles).map(k=>{
            return props.map.layers[props.map.activeLayer].fieldStyles[k].indexOf(activeField)>-1?k:false
        }).filter(e=>e);
        if(supportedFieldTypes.indexOf(curSType)===-1){
            setStyleType(supportedFieldTypes[0]);
            setStyleTypes(supportedFieldTypes);
            setStats({min:0, max:0, percentiles:[], values:[]})
        }
        loadFieldStats(props)
    }, [props.map.activeLayer, activeField])

    React.useEffect(()=>{
        reloadSld()
    }, [layerStyle])

    React.useEffect(()=>{
        if (props.map.activeLayer!="allum_project:settlements_1785") {
            const filtered = props.map.enabledBmaps.filter(obj => {
                return (obj!=="allum_project:megye1785" && obj!=="allum_project:megye1912"); // && obj!=="allum_project:vasutallomas" && obj!=="allum_project:vasutvonal");
            });
            filtered.push("allum_project:megye1912")
/*            filtered.push("allum_project:vasutallomas")
            filtered.push("allum_project:vasutvonal")*/

            props.map.enabledBmaps = filtered;
        } else {
            const filtered = props.map.enabledBmaps.filter(obj => {
                return (obj!=="allum_project:megye1785" && obj!=="allum_project:megye1912" && obj!=="allum_project:vasutallomas" && obj!=="allum_project:vasutvonal");
            });

            filtered.push("allum_project:megye1785")

            props.map.enabledBmaps = filtered;
        }
    })

    React.useEffect(()=>{
        if(stats.values.length===0){
            return;
        }
        let percentiles = [];
        if(styleType==='range'){
            // range type
            percentiles = calculatePercentiles(Array(division+1).fill(1).map((e,i)=>i/(division)), stats.values);
        }else{
            // category type
            if(props.map.activeLayer.includes("kulonb")||props.map.activeLayer.includes("grid")) {
                percentiles = stats.values.filter((v,i,a)=>a.indexOf(v)==i).sort((a,b)=>a-b)
                /*percentiles.sort((a, b) =>
                    // sort the string values alphabetically
                    a.localeCompare(b)
                );*/
            }
        }
        
        /* Setting the breaks and colors from the preloaded json */
        const found = preloaded.find(obj => {
            return obj.name === activeField;
          });

        let color_preloaded=[]
        let breaks_preloaded=[]

        if(styleType==='range'){
            // Set color ramp for choropleth maps
            breaks_preloaded=found.breaks
            color_preloaded=found.colors
            props.map.colorRamps[colorRamp].colors=color_preloaded
            percentiles = breaks_preloaded
        }else{
            if(props.map.activeLayer.includes("kulonb")||props.map.activeLayer.includes("grid")) {
                // Set color ramp for grid maps
                color_preloaded=props.map.colorRamps["colrampgrid"].colors
                props.map.colorRamps[colorRamp].colors=color_preloaded
            } else {
                // Set color ramp for categorical maps "Type3"
                breaks_preloaded=found.breaks
                percentiles = breaks_preloaded
                color_preloaded=found.colors
                props.map.colorRamps[colorRamp].colors=color_preloaded
            }
        }
        /* End of setting */
        

        setLayerStyle({
            colorRamp: props.map.colorRamps[colorRamp].colors,
            breaks: percentiles.map((p, idx)=>{
                if(styleType==='range'){
                    let nxt = (idx + 1)<percentiles.length?percentiles[idx + 1]:null;
                    
                    if((!nxt)&&(idx!=0)){
                        if (nxt==0) {
                            return {
                                name: `${p.constructor.name==='String'?(parseFloat(p)):p} - ${nxt.constructor.name==='String'?(parseFloat(nxt)):nxt}`,
                                values: [p, nxt],
                                color: color_preloaded[idx], //ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),
                                type: 'range'
                            }
                        } else {
                            return null;

                        }
                    }
                    if ((idx==0)&&(nxt==0)) {
                        return {
                            name: `<= ${nxt.constructor.name==='String'?(parseFloat(nxt)):nxt}`,
                            values: [p, nxt],
                            color: color_preloaded[idx], //ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),
                            type: 'range'
                        }
                    } else if (idx==0) {
                        return {
                            name: `< ${nxt.constructor.name==='String'?(parseFloat(nxt)):nxt}`,
                            values: [p, nxt],
                            color: color_preloaded[idx], //ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),
                            type: 'range'
                        }
                    } else if (idx==percentiles.length-2) {
                        return {
                            name: `> ${p.constructor.name==='String'?(parseFloat(p)):p}`,
                            values: [p, nxt],
                            color: color_preloaded[idx], //ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),
                            type: 'range'
                        }
                    } else {
                        return {
                            name: `${p.constructor.name==='String'?(parseFloat(p)):p} - ${nxt.constructor.name==='String'?(parseFloat(nxt)):nxt}`,
                            values: [p, nxt],
                            color: color_preloaded[idx], //ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),
                            type: 'range'
                        }
                    }
                }else{
                    if(props.map.activeLayer.includes("kulonb")||props.map.activeLayer.includes("grid")) {
                        return {
                            name: `${p}`,
                            values: [p, p],
                            color: ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),//'#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'),//
                            type: 'categorical'
                        }
                    } else {
                        return {
                            name: `${p}`,
                            values: [p, p],
                            color: props.map.colorRamps[colorRamp].colors[idx], //ColorUtils.getColor(idx, percentiles.length, props.map.colorRamps[colorRamp].colors),//'#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0'),//
                            type: 'categorical'
                        }
                    }
                }
            }).filter(e=>Boolean(e)),
            opacity: opacity/100
        })

    }, [stats, colorRamp, division, styleType])

    React.useEffect(()=>{
        setLayerStyle({
            colorRamp: layerStyle.colorRamp,
            breaks: layerStyle.breaks,
            opacity: opacity/100
        })
   }, [opacity])

   React.useEffect(()=>{
    props.map.layers["allum_project:basemap"].opacity=opacityBASE/100
    reloadSld()
}, [opacityBASE])

    let allIds = [
    "allum_project:allut_lines",
    "allum_project:megyeiut_lines",
    "allum_project:kozlut_lines",
    "allum_project:vasutallomas",
    "allum_project:vasutvonal",
    "allum_project:kikoto",
    "allum_project:folyokl",
    "allum_project:folyokm",
    "allum_project:tavak",
    "allum_project:jaras1912",
//    "allum_project:jarasgeo1912",
    "allum_project:megye1912",
    "allum_project:megye1785",
    "allum_project:mo1912",
    "allum_project:country_borders_2016"
];

    if (props.map.activeLayer=="allum_project:settlements_1785") {
        const filtered = allIds.filter(obj => {
            return (obj !== "allum_project:megye1912" && obj !== "allum_project:vasutallomas" && obj !== "allum_project:vasutvonal");
        });
        allIds=filtered;
    } else {
        const filtered = allIds.filter(obj => {
            return (obj !== "allum_project:megye1785");
        });
        allIds=filtered;
    }

    const basemapChange = (flag, bmId) => {
        console.log(flag, bmId)
        
        let _bmId = "allum_project:" + bmId;

        let prevBmIds = [...props.map.enabledBmaps];
        let cBmids = [];
        allIds.map(e=>{
            if(!flag && _bmId===e){
                //do nothing
            }else{
                if(prevBmIds.indexOf(e)>-1 || (flag && _bmId===e))
                    cBmids.push(e);
            }
        })
        dispatch(updateBms(cBmids))
    }

    const getbmState = (bmId) => {
        return props.map.enabledBmaps.indexOf(bmId)>-1;
    }


    return <div>
            {
                !showPanel?(
                    <IconButton style={{color: 'gray'}} onClick={()=>{setShowPanel(true)}} aria-label="delete">
                    <MenuIcon />
                </IconButton>):''
            }
            <Paper elevation={10} style={{minWidth: 300, display:showPanel?'block':'none', padding: 16, minWidth: 150, maxWidth: '37vmax', paddingLeft: 32, paddingRight:32, maxHeight: 'calc(100vh - 32px)', overflowY: 'auto', borderRadius:10, backgroundColor: '#f0f0f0'}}>
                        <IconButton style={{color:'gray', float:'right'}} onClick={()=>{setShowPanel(false)}} aria-label="delete">
                            <CloseIcon />
                        </IconButton>


                        <br/><br/>

                        <Button size="small" variant="contained" onClick={()=>{
                            setShowBMaps(!showBMaps)
                        }} endIcon={
                            // ''
                            !showBMaps?(''):(<CloseIcon />)
                        }>
                            {!showBMaps?("Toggle default layers"):("Close")}
                        </Button>
                        <Paper elevation={10} style={{
                            display: showBMaps?'block':'none', border:1, borderStyle:'solid', padding:15, borderColor: '#e0e0e0', marginTop:10, borderRadius:15, backgroundColor: '#ffffff'
                        }}>
                            
                            {/* <FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:allut_lines")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "allut_lines")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:allut_lines'} />allut_lines</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:kozlut_lines")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "kozlut_lines")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:kozlut_lines'} />kozlut_lines</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:megyeiut_lines")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "megyeiut_lines")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:megyeiut_lines'} />megyeiut_lines</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:vasutallomas")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "vasutallomas")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:vasutallomas'} />vasutallomas</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:vasutvonal")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "vasutvonal")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:vasutvonal'} />vasutvonal</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:kikoto")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "kikoto")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:kikoto'} />kikoto</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:folyokl")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "folyokl")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:folyokl'} />folyokl</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:jaras1912")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "jaras1912")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:jaras1912'} />jaras1912</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:jarasgeo1912")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "jarasgeo1912")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:jarasgeo1912'} />jarasgeo1912</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:mo1912")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "mo1912")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:mo1912'} />mo1912</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:megye1912")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "megye1912")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:megye1912'} />megye1912</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:folyokm")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "folyokm")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:folyokm'} />folyokm</div>} />
<br/>
<FormControlLabel control={<Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:tavak")>-1} />} onClick={(e)=>{basemapChange(e.target.checked, "tavak")}} label={<div><img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:tavak'} />tavak</div>} /> */}
                            
                            {
                                allIds.map(bmId=>{
                                    let _ = bmId.replace('allum_project:', '');

                                    const found = preloaded.find(obj => {
                                        return obj.name === _;
                                      });
                            
                                    return <>
                                    <FormControlLabel 
                                    control={
                                        <Checkbox checked={props.map.enabledBmaps.indexOf("allum_project:" + _)>-1} />
                                    }
                                    onClick={
                                        (e)=>{basemapChange(e.target.checked, _)}
                                    } label={
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                          }}>
                                            <div style={{flexBasis: '40%', paddingTop: 9}}>
                                            <img src={'http://193.225.239.5/geoserver/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=allum_project:' + _} />
                                            </div>
                                            <div style={{position:'relative', left:15, width:'500%'}}>
                                                {found.title}
                                            </div>
                                        </div>} /><br/>
                                        </>
                                })
                            }

                        </Paper>

                        <LayerDataSelection onLayerChange={(v)=>{
                            dispatch(toggleLayerState(v))
                        }} />

                        <br />
                        <Typography variant="caption" gutterBottom component="div">
                            Default layer opacity:
                        </Typography>
                        <Slider aria-label="Default layer opacity" value={opacityBASE} onChange={(e)=>{setOpacityBASE(e.target.value)}} />
                        
                        <Typography variant="caption" gutterBottom component="div">
                            Data layer opacity:
                        </Typography>
                        <Slider aria-label="Data layer opacity" value={opacity} onChange={(e)=>{setOpacity(e.target.value)}} />

                        <br />
                        
                        <Paper elevation={10} style={{border:1, borderStyle:'solid', padding:15, borderColor: '#e0e0e0', marginTop:10, borderRadius:15, backgroundColor: '#ffffff', display:'none'}}>
                        <Typography variant="caption" gutterBottom component="div">
                            Styles
                        </Typography>

                        <StyleTypeSelector styleTypes={styleTypes} value={styleType} onChange={(v)=>{
                            setStyleType(v)
                        }} />

                        <br />
                        <Typography variant="caption" gutterBottom component="div">
                            Color ramp:
                        </Typography>
                        <ColorRampSelector colorRamp={colorRamp} onChange={(v)=>setColorRamp(v)} />
                        <br />
                        <br />

                        {
                            styleType==='range'?(
                                <>
                                    <Typography variant="caption" gutterBottom component="div">
                                        Division:
                                    </Typography>
                                    
                                    <ColorDivisonSelector division={division} onChange={(v)=>setDivision(v)} />
                                </>
                            ):(
                                ''
                            )
                        }
                        
                        <br/>

                        {
                            openStyleEditor?(
                                <>
                                <StyleEditor styleType={styleType} styleData={layerStyle} onChange={(_ls)=>{
                                    setLayerStyle(_ls)
                                    reloadSld()
                                }} />
                                <br />
                                </>
                            ):''
                        }
                        <Button size="small" variant="contained" onClick={()=>{
                            setOpenStyleEditor(!openStyleEditor)
                        }} endIcon={
                            !openStyleEditor?(<EditIcon />):(<CloseIcon />)
                        }>
                            {!openStyleEditor?("Edit styles"):("Close")}
                        </Button>

                        </Paper>

                        {/* <IconButton aria-label="edit" style={{fontSize: 8}} onClick={()=>{
                            setOpenStyleEditor(!openStyleEditor)
                        }}>
                            {
                                !openStyleEditor?(<>
                                    <span>Edit</span>
                                    <EditIcon />
                                </>):(<DoneIcon />)
                            }
                            
                        </IconButton> */}
                        <LayerSelection onChange={(v)=>{
                            setActiveField(v)
                        }} />
                </Paper>
    </div>
}

export default connect(mapStateToProps)(DataPanel);